import { Loader2, AlertCircle } from "lucide-react";
import { cn } from "../lib/utils";

interface LoadingIndicatorProps {
  status: "loading" | "idle" | "saving" | "saved" | "error" | "unsaved";
  lastSaved?: Date | null;
  error?: string | null;
  className?: string;
}

export function LoadingIndicator({
  status,
  lastSaved,
  error,
  className,
}: LoadingIndicatorProps) {
  const getStatusContent = () => {
    switch (status) {
      case "loading":
      case "saving":
        return (
          <div className="flex items-center gap-2 text-blue-600 dark:text-link">
            <Loader2 className="w-4 h-4 animate-spin" />
            {/* <span className="text-sm font-medium">Saving...</span> */}
            {/* <span className="text-sm font-medium">Saving...</span> */}
          </div>
        );

      case "saved":
        return (
          <div className="flex items-center gap-2 text-green-600 dark:text-success">
            {/* <CheckCircle className="w-4 h-4" /> */}
            {/* <span className="text-sm">Saved {lastSaved ? `at ${lastSaved.toLocaleTimeString()}` : "successfully"}</span> */}
            <span className="text-xs text-center">
              {" "}
              {lastSaved ? `${lastSaved.toLocaleTimeString()}` : "successfully"}
            </span>
          </div>
        );

      case "error":
        return (
          <div className="flex items-center gap-2 text-red-600 dark:text-danger">
            <AlertCircle className="w-4 h-4" />
            <span className="text-xs">{error || "Save failed"}</span>
          </div>
        );

      case "unsaved":
        return (
          // <div className="flex items-center gap-2 text-orange-600 dark:text-warning">
          //   <Clock className="w-4 h-4" />
          //   <span className="text-sm">Unsaved changes</span>
          // </div>

          <div className="flex items-center gap-2 text-orange-600 dark:text-warning">
            {/* <Clock className="w-4 h-4" /> */}
            <span className="text-xs">Unsaved changes</span>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className={cn("transition-all duration-200", className)}>
      {getStatusContent()}
    </div>
  );
}
